(() => {
  const TOKEN_KEY = 'one-community-return-token-v1';
  const MAX_AGE_MS = 30 * 60 * 1000;
  const tokenPattern = /^[A-Za-z0-9_-]{43}$/;
  const host = document.getElementById('one-community-return-global');
  if (!host) return;

  const now = Date.now();
  const url = new URL(location.href);
  const inbound = url.searchParams.get('oneReturn');
  if (inbound && tokenPattern.test(inbound)) {
    sessionStorage.setItem(TOKEN_KEY, JSON.stringify({ token: inbound, storedAt: now }));
    url.searchParams.delete('oneReturn');
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
  }

  let saved = null;
  try { saved = JSON.parse(sessionStorage.getItem(TOKEN_KEY) || 'null'); } catch {}
  if (!saved || !tokenPattern.test(saved.token) || now - Number(saved.storedAt) > MAX_AGE_MS) {
    sessionStorage.removeItem(TOKEN_KEY);
    return;
  }

  const labels = {
    chat: 'Chat',
    feed: 'Feed',
    comment: 'Comment',
    announcements: 'Announcements'
  };

  const validate = new URL('/apps/one-academy/community-return/validate', location.origin);
  validate.searchParams.set('return', saved.token);
  validate.searchParams.set('path', location.pathname + location.hash);

  fetch(validate, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
    .then(response => response.ok ? response.json() : Promise.reject())
    .then(result => {
      const activeToken = tokenPattern.test(result.returnToken || '') ? result.returnToken : saved.token;
      if (activeToken !== saved.token) {
        saved = { token: activeToken, storedAt: now };
        sessionStorage.setItem(TOKEN_KEY, JSON.stringify(saved));
      }
      const label = labels[result.originContext] || 'Community';
      const link = document.createElement('a');
      link.className = 'one-community-return__link';
      link.href = '/apps/one-academy/community-return?return=' + encodeURIComponent(activeToken);
      link.setAttribute('aria-label', 'Return to ' + label);
      link.innerHTML = '<span aria-hidden="true">\u2190</span><span>' + label + '</span>';
      host.replaceChildren(link);
      host.hidden = false;
      document.documentElement.dataset.oneCommunityReturnGlobal = 'true';
      if (location.hash) {
        requestAnimationFrame(() => {
          let targetId = location.hash.slice(1);
          try { targetId = decodeURIComponent(targetId); } catch {}
          const target = document.getElementById(targetId);
          target?.scrollIntoView({ block: 'start' });
        });
      }
    })
    .catch(() => {
      sessionStorage.removeItem(TOKEN_KEY);
      host.hidden = true;
    });
})();
